/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.live.getProfileCard";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"id":/*#__PURE__*/ l.string()});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("*/*");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get an OG image associated with a given account. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["RepoNotFound"]);

export { main };

export const $lxm = $nsid;
